<template>
    <div class="wrapper">
        <v-head></v-head>
        <v-sidebar></v-sidebar>
        <div class="content-box" :class="{'content-collapse':collapse}">
            <v-tags></v-tags>
            <div class="content">
                <transition name="move" mode="out-in">
                    <keep-alive :include="tagsList">
                        <router-view></router-view>
                    </keep-alive>
                </transition>
            </div>
        </div>
        <div v-if ="updateNoticeMessage.length != 0 ">
            <noticePopup 
                :noticeInfo="updateNoticeMessage[number]" 
                @closeNotice ="closeNotice(updateNoticeMessage[number])"
                @JumpPage="JumpPage(updateNoticeMessage[number])"
                v-show ="noticeShow"/> 
        </div>
        <div v-if ="noticeInfo.length != 0 ">
        <warningPopup
            :warningInfo="noticeInfo[warningNumber]"
            @closeNotice="handleClose(noticeInfo[warningNumber])"
            @JumpPage="handleJump(noticeInfo[warningNumber])"
            v-show="warningPopupShow"
          />
        </div>
    </div>
</template>

<script>
    import vHead from './Header.vue';
    import vSidebar from './Sidebar.vue';
    import vTags from './Tags.vue';
    import bus from './bus';
    import noticePopup from "@/components/common/noticePopup";
    import warningPopup from "@/components/common/warningPopup";
    import {  personalCenterApi } from "@/api/personalCenter.js";
    import {  manageWarninApi } from "@/api/early_warning";

    export default {
        data(){
            return {
                tagsList: [],
                collapse: false,
                noticeMessage:[],
                noticeInfoOptions:[],
                warningMessage:[],
                number:0,
                warningNumber:0,
                noticeShow:true,
                warningPopupShow:true,
            }
        },
        computed:{
            noticeInfo(){
                let data = this.$store.state.websockData;
                if(data.length != 0){
                    data = data[0];
                    let arr = {};
                    if(data.type == "remind_over_number" ||data.type == "remind_over_time"){
                        this.warningPopupShow = true;
                        if(data.type == "remind_over_number"){
                        arr.title = "超量提醒";
                        }
                        else if(data.type == "remind_over_time"){
                            arr.title = "超时提醒";
                        }
                        for(let item of data.content){
                            if(data.type == "remind_over_number"){
                                arr.text = item.text;
                            }
                            if(data.type == "remind_over_time"){
                                arr.text = [];
                                arr.text.push(item.text);
                            }
                            arr.type = data.type;
                            arr.setting_id = item.setting_id;
                            arr.receipt_sn = item.receipt_sn;
                            this.warningMessage.push(arr); 
                        }
                    }
                    else if(data.type == "push_over_number" ||data.type == "push_over_time"){
                        this.warningPopupShow = true;
                        if(data.type == "push_over_number"){
                            arr.title = "超量提醒";
                            arr.text = data.content.text;
                        }
                        else if(data.type == "push_over_time"){
                            arr.text = [];
                            arr.text.push(data.content.text);
                            arr.title = "超时提醒";
                        }
                        arr.type = data.type;
                        arr.setting_id = data.content.setting_id;
                        arr.receipt_sn = data.content.receipt_sn;
                        this.warningMessage.push(arr); 
                    }else{
                        this.warningPopupShow = false;
                        return this.warningMessage
                    }
                }
                return this.warningMessage
            },
            updateNoticeMessage(){
                let data = this.$store.state.websockData;
                this.personalCenter();
                for(let item of data){
                     if(item.type === "push_notice" || item.type === "push_mission"){
                         this.noticeShow = true;
                         let noticePopup = {
                            title:"",
                            content:"",
                            type:""
                         }
                         if(item.content.notice_level === "1"){
                            noticePopup.title = "一级通知"
                        }
                        if(item.content.notice_level === "2"){
                            noticePopup.title = "二级通知"
                        }
                        if(item.type === "remind_mission"){
                            noticePopup.title = "问题交接"
                        }
                        if(item.type == "push_mission"){
                            noticePopup.title = "任务交接"
                        }
                        noticePopup.type = item.type;
                        noticePopup.content = item.content;
                        this.noticeInfoOptions.push(noticePopup);
                     }
                     else if(item.type === "remind_notice"){
                         this.noticeShow = true;
                         if(item.content.notice_level_1){
                            for(let tem of item.content.notice_level_1){
                                let noticePopup = {
                                    title:"一级通知",
                                    content:"",
                                    type:"",
                                }
                                noticePopup.type = "remind_notice";
                                noticePopup.content = tem;
                                this.noticeInfoOptions.push(noticePopup);
                            }                            
                         }
                         if(item.content.notice_level_2){
                            for(let tem of item.content.notice_level_2){
                                let noticePopup = {
                                    title:"二级通知",
                                    content:"",
                                    type:"",
                                }
                                noticePopup.type = "remind_notice";
                                noticePopup.content = tem;
                                this.noticeInfoOptions.push(noticePopup);
                            }                            
                         }
                     }
                    else if(item.type === "remind_mission"){
                        this.noticeShow = true;
                         for(let tem of item.content){
                                let noticePopup = {
                                    title:"任务交接",
                                    content:"",
                                    type:"",
                                }
                                noticePopup.type = "remind_mission";
                                noticePopup.content = tem;
                                this.noticeInfoOptions.push(noticePopup);
                            }        
                    }else{
                        this.noticeShow = false;
                        return this.noticeInfoOptions
                    }
                }
                return this.noticeInfoOptions;
            }
        },
        components:{
            vHead, vSidebar, vTags,noticePopup,warningPopup
        },
        methods:{
            JumpPage(item){
                this.noticeShow = false;
                if(this.noticeInfoOptions.length >0 && this.number < this.noticeInfoOptions.length){
                         if(this.number+1 < this.noticeInfoOptions.length){
                                this.number = this.number +1;
                                if(this.number+1 <= this.noticeInfoOptions.length){
                                        
                                        this.noticeShow = true;
                                        this.typecheck(item);
                                }else{
                                    
                                    this.noticeShow = false;
                                    this.typecheck(item);
                                    return;
                                }
                         }
                         else{
                             this.typecheck(item);
                             this.number = this.number+1;
                             return ;
                         }
                }
                else{
                    return;
                }
            },
            handleJump(item){
                this.warningPopupShow = false;
                if(this.warningMessage.length >0 && this.warningNumber < this.warningMessage.length){
                         if(this.warningNumber+1 < this.warningMessage.length){
                                this.warningNumber = this.warningNumber +1;
                                if(this.warningNumber+1 <= this.warningMessage.length){
                                        
                                        this.warningPopupShow = true;
                                        this.warningTypeCheck(item);
                                }else{
                                    
                                    this.warningPopupShow = false;
                                    this.warningTypeCheck(item);
                                    return;
                                }
                         }
                         else{
                             this.warningTypeCheck(item);
                             this.warningNumber = this.warningNumber+1;
                             return ;
                         }
                }
                else{
                    return;
                }
            },
            closeNotice(item){
                 this.noticeShow = false;
                if(this.noticeInfoOptions.length >0 && this.number < this.noticeInfoOptions.length){
                    if(this.number+1 < this.noticeInfoOptions.length){
                        this.number = this.number +1;
                        if(this.number+1 <= this.noticeInfoOptions.length){
                                this.noticeShow = true;
                        }else{
                            this.noticeShow = false;
                            return;
                        }
                    }
                    else{
                        this.number = this.number+1;
                        return ;
                    }
                }
                else{
                    return;
                }
            },
            handleClose(item){
                this.warningPopupShow = false;
                if(this.warningMessage.length >0 && this.warningNumber < this.warningMessage.length){
                    if(this.warningNumber+1 < this.warningMessage.length){
                        this.warningNumber = this.warningNumber +1;
                        if(this.warningNumber+1 <= this.warningMessage.length){
                                this.warningPopupShow = true;
                        }else{
                            this.warningPopupShow = false;
                            return;
                        }
                    }
                    else{
                        this.warningNumber = this.warningNumber+1;
                        return ;
                    }
                }
                else{
                    return;
                }
            },
            typecheck(item){
               if(item.type == "push_notice" || item.type == "remind_notice"){
                    let data = {};
                    data.id = item.content.id;
                    data = JSON.stringify(data)
                    this.$router.push({path:'/customer-time_notice',query: { data }});
                }else if(item.type == "remind_mission" || item.type == "push_mission"){
                    let data = {};
                    data.id = item.content.id;
                    data = JSON.stringify(data)
                    this.$router.push({path:'/customer-problem',query: { data }});
                }
            },
             warningTypeCheck(item){
                let data = {};
                data.receipt_sn = item.receipt_sn;
                data.id_array = item.setting_id;
                manageWarninApi(data)
                 .then(response=>{
                    if(item.type == "remind_over_number" || item.type == "push_over_number"){
                        if(this.$route.path == "/work-early-warning"){
                            return;
                        }
                        this.$router.push({path:'/work-early-warning'});
                    }
                    else if(item.type == "remind_over_time" || item.type == "push_over_time"){
                        if(this.$route.path == "/work-work_sn"){
                            return;
                        }
                        this.$router.push({path:'/work-work_sn'});
                    }
                 })
                 .catch(error=>{})
             },
             personalCenter(){
                personalCenterApi()
                    .then(response =>{
                    let data = response.data.data;
                    if(data.notice_level_3 != 0){
                        data.number = data.number - data.notice_level_3;
                    }
                    this.$store.commit("getNotice",data);
                    })
                    .catch(error =>{
                    })
                },

        },
        async created(){
            bus.$on('collapse', msg => {
                this.collapse = msg;
            })
            // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
            bus.$on('tags', msg => {
                let arr = [];
                for(let i = 0, len = msg.length; i < len; i ++){
                    msg[i].name && arr.push(msg[i].name);
                }
                this.tagsList = arr;
            })
        },
    }
</script>
